import {
  SEND_AECB_FTS_AUTHORIZATION,
  SEND_AECB_FTS_AUTHORIZATION_SUCCESS,
  SEND_AECB_FTS_AUTHORIZATION_FAIL
} from "../actions/sendAecbFtsEmail";
import { handleActions } from "../../utils/redux-utils";

export const initialState = {
  loading: false,
  loadingProspectId: null,
  isEmailSent: false,
  isEmailEnabled: true,
  emailResponse: {}
};

export default handleActions(
  {
    [SEND_AECB_FTS_AUTHORIZATION]: (state, { payload }) => ({
      ...state,
      loading: true,
      loadingProspectId: payload.prospectId,
      isEmailSent: false,
      isEmailEnabled: true,
      emailResponse: initialState.emailResponse
    }),
    [SEND_AECB_FTS_AUTHORIZATION_SUCCESS]: (state, { payload }) => ({
      ...state,
      loading: false,
      loadingProspectId: null,
      isEmailSent: true,
      isEmailEnabled: false,
      emailResponse: payload
    }),
    [SEND_AECB_FTS_AUTHORIZATION_FAIL]: state => ({
      ...state,
      loading: false,
      isEmailSent: false,
      isEmailEnabled: true,
      emailResponse: initialState.emailResponse
    })
  },
  initialState
);
